import {
	aiWorkflowApi,
	useGetUserAIWorkflowsQuery,
	useLazyGetAIWorkflowByIdQuery,
} from '@/features/aiWorkflow/aiWorkflowApi';
import { AI_WORKFLOW_STATUSES, AI_WORKFLOW_TYPES } from '@/features/aiWorkflow/constants';
import { useLazyGetDealRowQuery } from '@/features/deals/dealsApi';
import { showToast } from '@/features/toast/toastSlice';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { getUrlFromPipeline } from '@/utils/constants';
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const WORKFLOW_KEYS = Object.keys(AI_WORKFLOW_TYPES);

const useCheckAIWorkflows = () => {
	const dispatch = useDispatch();

	const account = useSelector((state) => state.msalAccount.account);
	const firebaseReady = useSelector((state) => state.firebase.firebaseReady);
	const email = account?.username;

	const { data: userDetails } = useGetUserDetailsQuery(
		{ email },
		{
			skip: !email,
		},
	);

	const { data, ...userAIWorkflowsQuery } = useGetUserAIWorkflowsQuery(
		{ userId: userDetails?.userId, complete: false },
		{ skip: !userDetails?.userId || !firebaseReady },
	);
	const incompleteWorkflows = data ?? [];
	const prevWorkflowsRef = useRef({});

	const [getAIWorkflow] = useLazyGetAIWorkflowByIdQuery();
	const [getDealRow] = useLazyGetDealRowQuery();

	useEffect(
		() =>
			console.log('Incomplete workflows', {
				incompleteWorkflows,
				ref: prevWorkflowsRef?.current,
			}),
		[incompleteWorkflows, prevWorkflowsRef?.current],
	);

	useEffect(() => {
		const currentById = Object.fromEntries(incompleteWorkflows.map((w) => [w.id, w]));

		for (const [id, workflow] of Object.entries(currentById)) {
			const { status, workflowType, dealId } = workflow;
			const prev = prevWorkflowsRef.current[id];

			if (prev && prev.status !== status && status === 'error') {
				getDealRow(dealId)
					.unwrap()
					.then((res) => {
						const pipelineUrl = getUrlFromPipeline(res.pipeline);
						console.error(`Uh oh! Workflow ${id} has failed`);
						dispatch(
							showToast({
								message: `There was an error with your ${AI_WORKFLOW_TYPES[workflowType]} workflow for deal ${dealId}.`,
								error: true,
								action: {
									path: `${pipelineUrl}/${dealId}`,
									label: 'GO TO DEAL',
								},
							}),
						);
					});
			}
		}

		for (const [id, prev] of Object.entries(prevWorkflowsRef.current)) {
			if (!currentById[id]) {
				getAIWorkflow({
					docId: id,
				})
					.unwrap()
					.then((res) => {
						console.log(res?.status);
						if (res?.status === AI_WORKFLOW_STATUSES.SUCCESS) {
							getDealRow(res.dealId)
								.unwrap()
								.then((deal) => {
									const pipelineUrl = getUrlFromPipeline(deal.pipeline);
									console.log(`Success! Workflow ${id} is complete`);
									dispatch(
										showToast({
											message: `${
												AI_WORKFLOW_TYPES[prev.workflowType]
											} workflow for deal ${prev.dealId} completed.`,
											success: true,
											action: {
												path: `${pipelineUrl}/${deal.dealId}`,
												label: 'GO TO DEAL',
											},
										}),
									);
								});
						} else {
							console.log('Workflow was deleted');
						}
					});
			}
		}

		prevWorkflowsRef.current = currentById;
	}, [incompleteWorkflows]);

	useEffect(() => {
		let intervalId;

		const checkRunStatus = async () => {
			dispatch(
				aiWorkflowApi.util.invalidateTags([
					{ type: 'AI_WORKFLOWS', id: `${userDetails?.userId}-false` },
				]),
			);

			incompleteWorkflows.forEach((workflow) => {
				const { dealId, workflowType } = workflow;
				dispatch(
					aiWorkflowApi.util.invalidateTags([
						{ type: 'AI_WORKFLOW', id: `${dealId}-${workflowType}` },
					]),
				);
			});
		};

		if (incompleteWorkflows.length > 0) {
			intervalId = setInterval(checkRunStatus, 10000); // Check every 10 seconds
		}

		return () => clearInterval(intervalId);
	}, [incompleteWorkflows]);
};

const NotificationChecker = () => {
	// const dispatch = useDispatch();

	useCheckAIWorkflows();

	// const account = useSelector((state) => state.msalAccount.account);
	// const email = account?.username;

	// const { data: userDetails } = useGetUserDetailsQuery(
	// 	{ email },
	// 	{
	// 		skip: !email,
	// 	}
	// );

	// const notifications = useSelector((state) => state.notifications);

	return <></>;
};
export default NotificationChecker;
